import { render, staticRenderFns } from "./PermissionPopup.vue?vue&type=template&id=c4f43072"
import script from "./PermissionPopup.vue?vue&type=script&lang=js"
export * from "./PermissionPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4f43072')) {
      api.createRecord('c4f43072', component.options)
    } else {
      api.reload('c4f43072', component.options)
    }
    module.hot.accept("./PermissionPopup.vue?vue&type=template&id=c4f43072", function () {
      api.rerender('c4f43072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main/PermissionPopup.vue"
export default component.exports